import styled from 'styled-components';

export const AppStyles = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-right: -5px;
    margin-left: -5px;
    box-sizing: border-box;
    width: 100%;
    padding: 15px;

    h2 {
        padding-right: 5px;
        padding-left: 5px;
        font-weight: 700;
    }
`;
